import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { commonModules } from 'src/app/app.config';
import { AuthButtonComponent } from 'src/app/components/auth-button/auth-button.component';
import { VenueService } from 'src/app/planvue-api';
import { ProfileService } from 'src/app/services/profile.service';

@Component({
  selector: 'app-landing',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss'],
  standalone: true,
  imports: [...commonModules, AuthButtonComponent]
})
export class WelcomeComponent  {
  profile = inject(ProfileService)
  venueService = inject(VenueService);
  router = inject(Router);
  constructor() {
    this.profile.user$.subscribe(() => {
        this.venueService.getVenues().subscribe((venues) => {
          if (venues.info.total == 1) {
            this.router.navigate(['/venue/', venues.items[0].id, 'map']);
          } else {
            this.router.navigate(['/venue']);
          }
        });
    })
  }
}
